/**
 * The name of the application.
 */
export const AREA_TYPE = "ESPACE_ECHANGE";
